import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';
import { DueDiligenceData } from '@Types/OrganizationDueDiligenceData';

export const useUpdateDueDiligenceDetails = () => {
  const [fetch, response] = useRequest<DueDiligenceData>();

  const updateDueDiligenceData = useCallback(
    (organization_id: number, data: any) =>
      fetch(API.paths.due_diligence(organization_id), 'patch', { data }),
    [fetch],
  );

  return [updateDueDiligenceData, response] as const;
};
